import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShoppingCart } = FiIcons;

const AFFILIATE_URL = 'https://amzn.to/46L71gr';

function handleAmazonClick() {
  if (typeof window.trackAmazonClick === 'function') {
    window.trackAmazonClick('sticky_mobile_cta', 'Jetzt auf Amazon ansehen');
  }
}

export const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-50 md:hidden px-4 pb-4 pt-2"
          style={{ background: 'linear-gradient(to top, #050c17 80%, transparent)' }}
        >
          <a
            href={AFFILIATE_URL}
            target="_blank"
            rel="noopener noreferrer sponsored"
            onClick={handleAmazonClick}
            data-action="amazon-click"
            data-source="sticky_mobile_cta"
            className="flex items-center justify-center gap-3 w-full py-4 bg-gold text-navy font-sans font-bold text-base rounded-2xl shadow-[0_0_30px_rgba(212,175,55,0.5)] active:scale-95 hover:brightness-110 transition-all duration-150"
          >
            <SafeIcon icon={FiShoppingCart} className="text-xl" />
            Jetzt auf Amazon ansehen
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};